import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/bundles`
}

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listBundles ({customerId, params}) {
        try {
            const response = await http.get(getPath(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, bundleId: number,  params: {}}} data
     * @returns {Promise<void>}
     */
    async showBundle ({customerId, bundleId}) {
        try {
            const response = await http.get(`${PATH}/${customerId}/bundles/${bundleId}`)
            return response
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, bundleId: number,  params: {}}} data
     * @returns {Promise<void>}
     */
    async listBundleNumbers ({customerId, bundleId, params}) {
        try {
            const path = getPath(customerId)
            const response = await http.get(
                `${path}/${bundleId}/numbers`,
                {params}
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async createBundle (data) {
        try {
            const path = getPath(data.customerId)
            const response = await http.post(
                `${path}/create`,
                data
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async updateBundle (data) {
        try {
            const path = getPath(data.customerId)
            const response = await http.put(
                `${path}/${data.bundleId}/update`,
                data
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
